const education = {
    "name": "Education",
    "data": [
        {
            "degree": "Engineering of Cybersecurity",
            "institution": "University of Information Technology",
            "location": "Ho Chi Minh, VN",
            "period": "2019 - 2023",
            "description": "Network & Cloud Security, Web + Mobile Pentesting Overview"
        }
    ]
}

export default education; 